export const GONG_HEADER = {
  CALL_BRIEF: "Call Brief",
  NEXT_STEPS: "Next Steps",
};
